import {NavLink} from 'react-router-dom';
import Icon from './Icon';
import {IconName} from '../icons/paths';

// DESIGN.md §5: 84px tall including 22px of home-indicator space, surface fill, top hairline,
// equal tabs. The active tab is shoot-text with its icon on a 56×30 shoot-soft pill.
const TABS: {to: string; label: string; icon: IconName}[] = [
    {to: '/journal', label: 'Journal', icon: 'journal'},
    {to: '/garden', label: 'Garden', icon: 'garden'},
    {to: '/plants', label: 'Plants', icon: 'leaf'},
    {to: '/todo', label: 'To do', icon: 'reminder'},
    {to: '/more', label: 'More', icon: 'more'}
];

export default function TabBar() {
    return (
        <nav
            aria-label="Main"
            className="fixed inset-x-0 bottom-0 z-20 border-t border-line bg-surface pb-[max(22px,env(safe-area-inset-bottom))]"
        >
            <ul className="mx-auto flex max-w-[560px] list-none p-0 m-0">
                {TABS.map(tab => (
                    <li key={tab.to} className="flex-1">
                        <NavLink
                            to={tab.to}
                            className={({isActive}) =>
                                `flex h-[62px] flex-col items-center justify-center gap-[3px] text-[11px] ${
                                    isActive ? 'font-bold text-shoot-text' : 'font-semibold text-ink-2'
                                }`
                            }
                        >
                            {({isActive}) => (
                                <>
                                    <span
                                        className={`flex h-[30px] w-[56px] items-center justify-center rounded-pill ${
                                            isActive ? 'bg-shoot-soft' : ''
                                        }`}
                                    >
                                        <Icon name={tab.icon} size={22} />
                                    </span>
                                    {tab.label}
                                </>
                            )}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
